<script setup lang="ts">
    import RuleEditor from '@views/Web/FormsList/RuleEditor.vue';
    import type { FormListItem } from '@views/Web/Forms.types';
    import { Permissions } from '@shared/Root/Permissions';
    import { formatDateTime } from '@shared/utils/formatDateTime';

    defineProps<{
        item: FormListItem;
        index: number;
        current: number;
        currentFormsRules: string;
        widgetRuleset: any | null;
    }>();

    const emit = defineEmits<{
        (event: 'edit-rules', index: number): void;
        (event: 'copy-form', webContentId: string): void;
        (event: 'update:hasChanges', value: boolean): void;
    }>();
</script>

<template>
    <div class="flex-1" style="min-width: min(400px, 100%)">
        <h4>
            <RouterLink :to="{ name: 'FormsEditor', params: { webContentId: item.WebContentId } }">
                {{ item.Name && item.Name.trim() ? item.Name : $Resources.FormsListNoNamePlaceholder }}
            </RouterLink>
        </h4>

        <p v-show="item.Description">{{ item.Description }}</p>

        <p class="meta">
            <span class="glyphicon glyphicon-time" aria-hidden="true"></span>
            {{ $Resources.GenericCreatedLabel }}
            <time :datetime="item.Created">{{ formatDateTime(item.Created) }}</time>
            {{ $Resources.GenericByLabel }}
            {{ item.CreatedBy?.Name }}

            <i class="fa fa-pencil" aria-hidden="true"></i>
            {{ $Resources.LastModifiedLabel }}
            <time :datetime="item.Modified">{{ formatDateTime(item.Modified) }}</time>
            {{ $Resources.GenericByLabel }}
            {{ item.ModifiedBy?.Name }}
        </p>
    </div>
    <div style="align-self: center">
        <div v-if="index === current" class="m-xs-b">
            <rule-editor
                :currentFormsRules="currentFormsRules"
                @update:rules="(newValue) => emit('update:hasChanges', newValue)"
                :form="item"
                :widgetRuleset="widgetRuleset"></rule-editor>
        </div>
        <div class="m-xs-b" v-else v-require-scope="{ Feature: 'Widgets', Permission: Permissions.Write }">
            <button type="button" class="btn btn-default" @click="emit('edit-rules', index)">{{ $Resources.FormsEditRulesBtn }}</button>
        </div>
    </div>
    <div style="align-self: center">
        <div class="m-xs-b">
            <button type="button" class="btn btn-subtle" :disabled="current !== -1" @click="emit('copy-form', item.WebContentId)">
                {{ $Resources.FormsEditCopyBtn }}
            </button>
        </div>
    </div>
</template>
